// extracted by mini-css-extract-plugin
export default {"currentPositionPin":"PickupAddressMap_currentPositionPin__3W8LR"};